(function () {
    'use strict';

    function documentResourcesGroupConfigurationContent() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/documentResourcesGroupConfigurationContent.html',
            link: function (scope) {
            }
        };
    }

    documentResourcesGroupConfigurationContent.$inject = [];

    angular.module('ecap.siteConfiguration').directive('documentResourcesGroupConfigurationContent', documentResourcesGroupConfigurationContent);
})();

